export {map as ambili} from './ambili.js';
export {map as banglapedia} from './banglapedia.js';
export {map as charaka } from './charaka';
export {map as haritha } from './haritha';
export {map as haritha_bold } from './haritha_bold';
export {map as indulekha } from './indulekha';
export {map as karthika } from './karthika';
export {map as manorama } from './manorama';
export {map as matweb } from './matweb';
export {map as nandini } from './nandini';
export {map as panchari } from './panchari';
export {map as revathi } from './revathi';
export {map as uma } from './uma';
export {map as valluvar } from './valluvar';

export const maps = "ambili banglapedia charaka haritha haritha_bold indulekha karthika manorama matweb nandini panchari revathi uma valluvar".split(' ');
